import React from "react";
import Header from "../Component/Header";
import About from "../Component/Aboutus";

const Aboutus = () => {
  return (
    <div>
      <About />
    </div>
  );
};

export default Aboutus;
